import React from 'react';
import { IconButton, List, ListItemText } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { CloseRounded } from '@mui/icons-material';

interface BrowsingFiltersDropdownProps {
  title: string;
  options: string[];
  setFilter: (selectedOption: string) => void;
}


const BrowsingFiltersDropdown: React.FC<BrowsingFiltersDropdownProps> = ({ title, options, setFilter }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

  const handleMenuItemClick = (
    _event: React.MouseEvent<HTMLElement>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setFilter(options[index])
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearFilter = () => {
    setSelectedIndex(null);
    setFilter('')
  }

  return (
    <div style={{display: "flex", flexDirection: "row", alignContent: "center", alignItems: "center"}}>
      <List
        component="nav"
        aria-label="Browsing Filters"
        sx={{ bgcolor: 'background.paper' }}
      >
        <ListItemButton
          id="browsing-filters-menu-button"
          aria-haspopup="listbox"
          aria-controls="filter-menu"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
        >
          <ListItemText
            primary={title}
            secondary={selectedIndex === null ? "-" : options[selectedIndex]}
            sx={{justifyContent: "center", justifyItems: "center"}}
          />
        </ListItemButton>
      </List>
      <Menu
        id="lock-menu"
        variant='menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
      <IconButton>
        <CloseRounded onClick={handleClearFilter} />
      </IconButton>
    </div>
  );
}

export default BrowsingFiltersDropdown;
